<span [matTooltip]="tooltipText" [matTooltipPosition]="tooltipPosition">
  {{ input.text | parse: context | async }}
</span>
